import React, { useEffect,useState } from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useSelector } from "react-redux";
import {pathOr} from "ramda";

//import { formatDate } from "../../../common/utils";

const DateField = ({ field, onChange, errors = {}, value, small = false }) => {
	const [defaultValue,setDefaultValue]=useState(value);
	const { userPreference, config } = useSelector((state) => state.config);
	const timezone = pathOr('', ['attributes', 'global','timezone'], userPreference);
	const timef = pathOr(pathOr('', ['default_time_format'],config), ['attributes', 'global','timef'], userPreference);
	const datef = pathOr(pathOr('', ['default_date_format'],config), ['attributes', 'global','datef'], userPreference);
	const date_reg_format = pathOr(pathOr('', ['default_date_format'],config), ['attributes', 'global','date_reg_format'], userPreference);
	const time_reg_format = pathOr(pathOr('', ['default_date_format'],config), ['attributes', 'global','time_reg_format'], userPreference);
	const date_reg_positions = pathOr(pathOr('', ['default_date_format'],config), ['attributes', 'global','date_reg_positions'], userPreference);
	
	let newDatef= datef.replace("Y","yyyy");
	newDatef= newDatef.replace("m","MM");
	newDatef= newDatef.replace("d","dd");

	let iserror = errors[field.name] ? true : false;
	let isRequired = field.required === 'true' ? '*' : '';

	const handleChange = (date,newDatef) => {
		if(date && date !='Invalid Date')
		{
			onChange(newDatef);
			delete errors[field.name];
		}else{
			onChange("");
			errors[field.name]= "Invalid Date";
		} 		

	};
	const isTime = (timeStr) =>{
		var timeRegex = time_reg_format;
		timeRegex = timeRegex.replace(/[ ]*\([^)]*m\)/i, '');
		if (timeStr.length == 0) {
			return true;
		}
		let myregexp = new RegExp(timeRegex);
		if (!myregexp.test(timeStr)) {
			return false;
		}
		return true;
	}

	const getDateObject=(dtStr) =>{
		if (dtStr.length === 0) {
			return true;
		}
		let myregexp = new RegExp(date_reg_format);
		if (myregexp.exec(dtStr)){
			var dt = myregexp.exec(dtStr);
		}
		else{
		return false;
		}
		var yr = dt[date_reg_positions['Y']];
		var mh = dt[date_reg_positions['m']];
		var dy = dt[date_reg_positions['d']];
		var dtar = dtStr.split(' ');
		var date1='';
		if (typeof (dtar[1]) != 'undefined' && isTime(dtar[1],time_reg_format)) {
			var t1 = dtar[1].replace(/am/i, ' AM');
			t1 = t1.replace(/pm/i, ' PM');
			t1 = t1.replace(/\./, ':');
			date1 = new Date(mh + '/' + dy + '/' + yr + ' ' + t1);
		} else {
			date1 = new Date(yr + '-' +mh + '-' +  dy);
		}
		if (isNaN(date1.valueOf())) {
			return null;
		}
		return date1;
	}

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<KeyboardDatePicker
			allowKeyboardControl={false}
				autoOk
				error={iserror}
				variant="inline"
				inputVariant="outlined"
				label={field.label?field.label + " " + isRequired:null}
				id={field.name}
				name={field.name}
				format={newDatef}
				value={value?getDateObject(value):''}
				fullWidth
				size={small ? 'small' : 'medium'}
				InputAdornmentProps={{ position: 'end' }}
				minDate={field.minDate?field.minDate:''}
				maxDate={field.maxDate?field.maxDate:''}
				onChange={(date,newDatef) => handleChange(date,newDatef)} //onChange(formatDate(date))
				helperText={errors[field.name] ? errors[field.name] : null}
	inputValue={value}

			/>
		</MuiPickersUtilsProvider>
	);
};

export default DateField;
